<template>
  <div style="width: 1200px; margin: 0 auto">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
      background-color="#000"
      text-color="#fff"
      active-text-color="#1f9d56"
    >
      <el-menu-item>
        <div @click="toHome()">
          <img
            width="117px"
            alt="logo"
            src="/official/static/img/home/logo_01.svg"
          >
        </div>
      </el-menu-item>

      <el-menu-item>
        <a
          href="https://access.gaminglabs.com/Certificate/Index?i=277"
          aria-label
          target="_blank"
        >
          <img
            style="width: 64px"
            src="/official/static/img/home/caming.png"
            alt="gaming"
          >
        </a>
      </el-menu-item>

      <el-menu-item
        class="el-menu-item-margin"
        style="width: 150px; text-align: center; padding: 0px"
        index="/home"
      >
        <div @click="toHome()">
          {{ $t("common.p2") }}
        </div>
      </el-menu-item>

      <el-popover
        id="el-popover-menu"
        placement="top"
        trigger="hover"
        width="1200"
        :visible-arrow="false"
      >
        <div class="container">
          <div
            class="popular-content"
            :style="popoverStyle"
          >
            <div style="display: inline-block; width: 150px">
              <span
                style="cursor: pointer"
                @click="toEvents"
              >{{
                $t("common.p4")
              }}</span>
              <span
                style="cursor: pointer"
                @click="toFestival"
              >{{
                $t("common.p5")
              }}</span>
            </div>
            <div style="display: inline-block; width: 150px">
              <span
                v-for="item in tabs"
                :key="item.id"
                @click="toBlog(item.id)"
              >{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div
          slot="reference"
          style="display: inline-block"
        >
          <el-menu-item
            index="/events"
            style="width: 150px; text-align: center; padding: 0px"
          >
            <div
              style="color: inherit"
              @click="toEvents()"
            >
              {{ $t("common.p3") }}
            </div>
          </el-menu-item>
          <el-menu-item
            index="/blog"
            style="width: 150px; text-align: center; padding: 0px"
          >
            <div
              style="color: inherit"
              @click="toBlogHome()"
            >
              {{ $t("common.p6") }}
            </div>
          </el-menu-item>
          <!-- <el-menu-item index="/faq" style="width: 200px;text-align:center;padding: 0px;">
              <a style="color:inherit;" href="/faq">{{ $t('common.p7') }}</a>
            </el-menu-item> -->
        </div>
      </el-popover>

      <el-menu-item class="contact-us">
        <a
          target="_blank"
          href="/about"
        >{{ $t("common.p21") }}</a>
      </el-menu-item>
      <!-- Test -->
      <a
        target="_blank"
        class="night"
        href="//www.pppoker.net/ppknight/"
      > PP KNIGHT </a>
      <div class="lang">
        <lang-select />
      </div>

      <div class="icon">
        <a
          target="_blank"
          href="https://www.facebook.com/pppoker123"
          aria-label
          class="facebook-img"
        />
        <a
          target="_blank"
          href="https://www.instagram.com/pppokerglobal"
          aria-label
          class="instagram-img"
        />
        <a
          target="_blank"
          href="https://www.youtube.com/channel/UCpklAxJQBUEoFISwCn9o4jg?view_as=subscriber"
          aria-label
          class="youtube-img"
        />
      </div>
    </el-menu>
  </div>
</template>

<script>
// @ is an alias to /src
import LangSelect from "./LangSelect.vue";
import { getBlogTab } from "@/api/official";

export default {
  components: {
    LangSelect,
  },
  data() {
    return {
      popover: false,
      popoverStyle: {},
      tabs: [],
    };
  },
  computed: {
    activeIndex() {
      return this.$store.state.tab;
    },
  },
  created() {
    this.initData();
  },
  mounted() {
    setTimeout(() => {
      console.log(document.querySelector("#el-popover-menu").offsetLeft);
      this.popoverStyle = {
        left: "361px", // document.querySelector('#el-popover-menu').offsetLeft - 10 + 'px'
      };
    }, 10);
  },
  methods: {
    initData() {
      getBlogTab()
        .then((res) => {
          this.tabs = res.data.list.map((v) => {
            // this.initBlogList(v.id)
            return { name: v.lang[this.$i18n.locale], id: v.id + "" };
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toHome() {
      this.$router.push({ name: "home" });
    },
    toBlogHome() {
      this.$router.push({ name: "blog" });
    },
    toBlog(id) {
      this.$router.push({ name: "blog", query: { tab: id } });
    },
    toFaq(id) {
      this.$router.push({ name: "faq", query: { index: id } });
    },
    toEvents() {
      this.$router.push({ name: "events" });
    },
    toFestival() {
      this.$router.push({ name: "festival" });
    },
    // toHome () {
    //   this.$router.push({ name: 'home', query: { t: Date.now() } })
    // },
    // toBlogHome () {
    //   this.$router.push({ name: 'blog', query: { t: Date.now() } })
    // },
    // toBlog (id) {
    //   this.$router.push({ name: 'blog', query: { tab: id, t: Date.now() } })
    // },
    // toFaq (id) {
    //   this.$router.push({ name: 'faq', query: { index: id, t: Date.now() } })
    // },
    // toEvents () {
    //   this.$router.push({ name: 'events', query: { t: Date.now() } })
    // },
    // toFestival () {
    //   this.$router.push({ name: 'festival', query: { t: Date.now() } })
    // }
  },
};
</script>

<style lang="scss">
.el-popover.el-popper {
  background: rgba(0, 0, 0, 0.6);
  border: none;
  margin-top: 3px !important;
  padding: 0px;
  width: 100% !important;
  min-width: 1200px !important;
  left: 0px !important;
  .popular-content {
    position: relative;
    width: 600px;
    top: 0px;
    left: 20px;
    // text-align: center;
    font-size: 14px;
    padding: 10px 0px 16px 0px;
    div {
      vertical-align: top;
      text-align: center;
    }
    span {
      color: #fff;
      display: block;
      line-height: 32px;
      cursor: pointer;
      &:hover {
        color: #1f9d56;
      }
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.el-menu-demo {
  position: relative;
  a {
    cursor: pointer;
  }
}
.el-menu.el-menu--horizontal {
  border-bottom-color: #000;
  .el-menu-item {
    height: 57px;
    line-height: 57px;
    font-size: 18px;
    color: #d2d2d2;
    padding: 0 10px;
    border-bottom: none;
    display: inline-block;
    a {
      display: block;
    }
    &:hover {
      a {
        color: #1f9d56 !important;
      }
    }
  }
  .el-menu-item-margin {
    padding: 0 35px;
  }
  .contact-us {
    float: right;
    font-size: 14px;
    padding: 0 10px;
  }
  .el-dropdown-link {
    cursor: pointer;
    font-size: 14px;
    color: #d2d2d2;
  }
  .night {
    font-size: 18px;
    padding: 0 10px;
    color: #fff;
  }
  .lang {
    float: right;
    height: 58px;
    line-height: 60px;
    padding: 0 10px;
    cursor: pointer;
    list-style: none;
    border-bottom: 2px solid transparent;
    &:focus {
      outline: none;
    }
  }
}

.icon {
  float: right;
  padding-top: 15px;

  a {
    margin: 0 10px;
    display: inline-block;
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: center center;
    width: 24px;
    height: 32px;
  }
  .facebook-img {
    background-image: url(/official/static/img/home/2_facebook_w.svg);
    &:hover {
      background-image: url(/official/static/img/home/2_facebook_g.svg);
    }
  }
  .instagram-img {
    background-image: url(/official/static/img/home/2_ins_w.svg);
    &:hover {
      background-image: url(/official/static/img/home/2_ins_g.svg);
    }
  }
  .youtube-img {
    background-image: url(/official/static/img/home/2_youtube_w.svg);
    &:hover {
      background-image: url(/official/static/img/home/2_youtube_g.svg);
    }
  }
  .twitter-img {
    background-image: url(/official/static/img/home/2_twitter_w.svg);
    &:hover {
      background-image: url(/official/static/img/home/2_twitter_g.svg);
    }
  }
}
</style>
